export const b2bUrl: string = '/pro/front/api/v1/';
export const methodNameRegExp: string = '"method":s*"([^"]+)"';

export enum MethodPropertiesKey {
  TEAM = 'team',
}
